import React from 'react';
import Chip from '@mui/material/Chip';
import { makeStyles } from '@mui/styles';
import HighlightText from '@/components/HighlightText/HighlightText';
import UniversalChip from '@/components/UI/UniversalChip/UniversalChip';
import { chipTypes, fieldTypes } from '@/helpers/constants';
import { WKZNamePlant } from '@/types';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    margin: 0,
  },
  rootDisabled: {
    backgroundColor: theme.cartTheme.contentBackgroundColor,
    padding: '10px',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

type PlantChipsProps = {
  onChange: (value: string) => void;
  list: string[] | WKZNamePlant[];
  checkEnabled: boolean;
  fieldPath: string[];
};

const PlantChips: React.FC<PlantChipsProps> = (props) => {
  const { onChange, list = [], checkEnabled, fieldPath } = props;

  const classes = useStyles();

  return (
    <ul id="plant-chips" className={`${classes.root} ${checkEnabled ? classes.rootDisabled : ''}`}>
      {checkEnabled
        ? (
          <UniversalChip
            chipType={chipTypes.READONLY}
            arrayStrings={list.map((option) => option?.plantName || option)}
            fieldPath={fieldPath}
          />
        )
        : (list.map((option, index) => (
          <li key={option.wkzNumber || option}>
            <Chip
              disabled={checkEnabled}
              label={(
                <HighlightText
                  fieldId="plant-chips"
                  fieldPath={[fieldPath[0], fieldPath[1], fieldPath[2], `${fieldPath[3]}[${index}]`]}
                  fieldType={fieldTypes.CHIP}
                >
                  {option.plantName || option}
                </HighlightText>
              )}
              size="small"
              onDelete={() => onChange(option.wkzNumber)}
              className={classes.chip}
            />
          </li>
        )))}
    </ul>
  );
};

export default PlantChips;
